import React from "react";
import { View } from "react-native";
import { DEVICE_SIZES } from "rn-responsive-styles";
import Skeletons from "./Skeletons";

const MessagePopupSkeleton = ({ deviceSize }) => {
  return (
    <View>
      {/* Header: Title and Close Button */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Skeletons height={20} width={"120px"} style={{ borderRadius: 6 }} />
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 20
              : 25
          }
          width={
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? "20px"
              : "25px"
          }
          style={{ borderRadius: 12.5 }}
        />
      </View>
      <Skeletons
        height={1}
        width="100%"
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      {/* Tab Buttons */}
      <View style={{ flexDirection: "row", gap: 20 }}>
        {[...Array(3)].map((_, index) => (
          <Skeletons
            key={index}
            height={32}
            width={"100px"}
            style={{ borderRadius: 57 }}
          />
        ))}
      </View>
      <Skeletons
        height={1}
        width="100%"
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      {/* Message Items */}
      {[...Array(3)].map((_, index) => (
        <View key={index}>
          <View style={{ flexDirection: "row", alignItems: "center", paddingLeft: 12 }}>
            <Skeletons
              height={48}
              width={"48px"}
              style={{ borderRadius: 78, marginLeft: 16, marginRight: 20 }}
            />
            <View style={{ width: "70%" }}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingBottom: 10,
                }}
              >
                <Skeletons
                  height={16}
                  width={"100px"}
                  style={{ borderRadius: 6 }}
                />
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <Skeletons
                    height={12}
                    width={"80px"}
                    style={{ borderRadius: 6 }}
                  />
                  <Skeletons
                    height={16}
                    width={"16px"}
                    style={{ borderRadius: 8 }}
                  />
                </View>
              </View>
              <Skeletons height={14} width="90%" style={{ borderRadius: 6 }} />
            </View>
          </View>
          <Skeletons
            height={1}
            width="100%"
            style={{ marginTop: 12, marginBottom: 12 }}
          />
        </View>
      ))}
      {/* View All Button */}
      <Skeletons
        height={20}
        width={"80px"}
        style={{ borderRadius: 6, alignSelf: "center" }}
      />
    </View>
  );
};

export default MessagePopupSkeleton;
